var xP = require('../xP');

module.exports = {
  name: '_combolist', base: 'select', prototype: {
    element_selector: '.combolist select, select.combolist',

    init: function (params) {
      xP.controls._combolist.base.init.apply(this, arguments);

      this.$element
        .css({'position': 'absolute', 'z-index': 888})
        .attr('size', 7).attr('tabIndex', -1)
        .hide()[0].selectedIndex = -1;
      ;
    },

    show: function () {
      if (!this._param('do_not_show') && this.$element[0].options.length) {
        this.$element.show();
      }
      return this;
    },

    hide: function () {
      if (!this._param('do_not_hide')) {
        this.$element.hide();
      }
      return this;
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/_combolist.js
 ** module id = 3
 ** module chunks = 0
 **/